import "../index.scss";
import { useTranslation } from "react-i18next";
import IframeComm from "react-iframe-comm";
import { useEffect, useState } from "react";
import { useToast, Box, Typography, Button, getColor, Icons } from "fds";
import {
  getUserInfoFromLocalStorage,
  setRedirectUrl,
} from "../../../shared/utils/auth";
import utilsDocs from "../../../shared/utils/docs";
import { LoginDto } from "../../../types/auth";
import { useNavigate } from "react-router-dom";
import useLoginStore from "../../../redux/dispatcher/useLoginStore";
import { handleDocDownload } from "../../../shared/utils/api";
import useDocumentStore from "../../../redux/dispatcher/useDocumentStore";
import { nanoid } from "@reduxjs/toolkit";
interface IProps {
  uniqueId: string;
  accessUrl?: string;
  urlAction: string;
  syncId: string;
  webviewStatus: string;
  otp?: string;
}
const NoAuthPreview: React.FC<IProps> = ({
  accessUrl,
  uniqueId,
  syncId,
  webviewStatus,
  urlAction,
  otp,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const toasts = useToast();
  const { getContentDownload } = useDocumentStore();
  const { loginState, getFileUrlDownloadFromUid, getFileSimpleInfo } =
    useLoginStore();
  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto = JSON.parse(user) as LoginDto;
  const [content, changeFileInfo] = useState({
    contentName: "",
    fileSize: 0,
  });
  const handleDownloadFile = (): void => {
    getFileUrlDownloadFromUid({ uid: uniqueId, token: otp }).then(
      (result: any) => {
        if (result.error) {
          if (
            result.error.name &&
            result.error.name !== "INTERNAL_SERVER_ERROR"
          ) {
            toasts.toastMsg(nanoid(), result.error.message, "error");
          } else {
            toasts.toastMsg(nanoid(), t("file.alert.downloadFail"), "error");
          }
        }
      }
    );
  };
  useEffect(() => {
    getFileSimpleInfo(syncId).then((resp: any) =>
      changeFileInfo({
        contentName: resp.payload?.contentName ?? "",
        fileSize: resp.payload?.fileSize ?? 0,
      })
    );
  }, [syncId]);
  const renderNoSupprtExtPage = (): React.ReactNode => {
    return (
      <Box
        width={"100%"}
        height={"100%"}
        alignItems="center"
        justifyContent="center"
      >
        <Box
          direction="column"
          width={544}
          alignItems="center"
          justifyContent="center"
          height={"100%"}
        >
          <img
            src={require("../../../shared/images/pages/File/emptyFilterDoc.png")}
            alt="no_content"
          />
          <Typography type={"h3"} lineHeight="24px" classes="mg mt-20">
            {t("login.link.noPreview")}
          </Typography>
          <Typography
            type="body2_rg"
            classes="mg mt-8"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {t("login.link.unSupprtExt")}
          </Typography>
          {urlAction === "WEBUSING" ? (
            <Typography
              type="body2_rg"
              classes="mg mt-8"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {t("login.link.askAdminDownload")}
            </Typography>
          ) : (
            <Button
              classes={"mg mt-20"}
              leadingIcon={<Icons variant={"line"} label={"download"} />}
              onClick={handleDownloadFile}
              btnStyle="fill"
              label={t("file.action.download")}
            />
          )}
          {!loginDto ? (
            <>
              <hr
                className="divider"
                style={{ margin: "32px 0 20px 0", width: 448 }}
              />
              <Typography type="body1_rg">
                {t("login.link.askAdminUse")}
              </Typography>
              <Box
                width={"100%"}
                height={40}
                justifyContent="space-evenly"
                classes="mg mt-20"
              >
                <Button
                  label={t("login.title")}
                  type="secondary"
                  width={101}
                  btnStyle="fill"
                  onClick={moveToLoginPage}
                />
              </Box>
              <hr
                className="divider"
                style={{ margin: "20px 0 18px 0", width: 448 }}
              />
              <Box width={"100%"} direction="column" justifyContent="center">
                <Box alignItems="center" justifyContent="center">
                  <Typography
                    type="body3_rg"
                    exactColor={getColor("COLOR_TEXT_SECONDARY")}
                  >
                    {t("login.link.noAccount")}
                  </Typography>
                  <Typography
                    classes="mg ml-4 hover-text-underline"
                    onClick={() =>
                      navigate(`${process.env.PUBLIC_URL}/checkSignup`)
                    }
                    type="body3_rg"
                    exactColor={getColor("COLOR_TEXT_BRAND")}
                  >
                    {t("login.signup")}
                  </Typography>
                </Box>
                <Box
                  alignItems="center"
                  classes="mg mt-8"
                  justifyContent="center"
                >
                  <Typography
                    type="body3_rg"
                    exactColor={getColor("COLOR_TEXT_SECONDARY")}
                  >
                    {t("login.login.newECO")}
                  </Typography>
                  <Typography
                    classes="mg ml-4 hover-text-underline"
                    onClick={() =>
                      navigate(`${process.env.PUBLIC_URL}/service`)
                    }
                    type="body3_rg"
                    exactColor={getColor("COLOR_TEXT_BRAND")}
                  >
                    {t("login.login.serviceAndDownload")}
                  </Typography>
                </Box>
              </Box>
            </>
          ) : (
            urlAction === "WEBUSING" && (
              <Box width={360}>
                <Button
                  classes={"mg mt-40"}
                  onClick={moveToLoginPage}
                  width={"100%"}
                  btnStyle="fill"
                  label={t("login.link.goHome")}
                />
              </Box>
            )
          )}
        </Box>
      </Box>
    );
  };
  const moveToLoginPage = () => {
    setRedirectUrl(`/docs/preview?permission=view&syncId=${syncId}`);
    navigate(`${process.env.PUBLIC_URL}/login`);
  };
  return (
    <Box classes="noAuthPreview">
      <Box classes="noAuthPreview-header">
        {utilsDocs.renderDocIcon(content.contentName, 48)}
        <Box
          classes="mg ml-8"
          direction="column"
          justifyContent="space-around"
          height={"100% "}
        >
          <Typography type="subtitle2">{content.contentName}</Typography>
          <Typography type="body2_rg">
            {`${utilsDocs.fileSizeFormat(
              content.fileSize
            )} • ${utilsDocs.fileFormattoStr(content.contentName)}`}
          </Typography>
        </Box>
        {urlAction.includes("DOWNLOAD") && (
          <Button
            leadingIcon={<Icons variant="line" label="download" />}
            onClick={handleDownloadFile}
            btnStyle="link"
            label={t("file.action.download")}
            classes="mg ml-auto"
          />
        )}
        {urlAction === "WEBUSING" && (
          <Button
            leadingIcon={<Icons variant="line" label="user" />}
            onClick={() => {
              if (loginDto) {
                setRedirectUrl(
                  `/docs/preview?permission=view&syncId=${syncId}`
                );
                navigate(
                  `${process.env.PUBLIC_URL}/docs/preview?permission=view&syncId=${syncId}`
                );
              } else moveToLoginPage();
            }}
            btnStyle={"link"}
            label={t("login.title")}
            classes="mg ml-auto"
          />
        )}
      </Box>
      {accessUrl || !["SUCCESS", "FAIL", "DELETED"].includes(webviewStatus) ? (
        <IframeComm
          attributes={{
            src: accessUrl,
            width: "100%",
            height: "100%",
            id: "office",
            sandbox:
              "allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation allow-popups-to-escape-sandbox",
            display: "block",
            allowFullscreen: "true",
            position: "relative",
          }}
        />
      ) : (
        renderNoSupprtExtPage()
      )}
    </Box>
  );
};

export default NoAuthPreview;
